import { useEffect, useState } from "react";
import { API } from "../../../services/api";

// Filtres du suivi et référentiels des listes déroulantes (EHPAD, tournées).
export function useSuiviFilters() {
    const [ehpads, setEhpads] = useState([]);
    const [ehpadsLoaded, setEhpadsLoaded] = useState(false);
    const [tournees, setTournees] = useState([]);
    const [dateReception, setDateReception] = useState("");
    const [statutMode, setStatutMode] = useState("TOUS");
    const [ehpadId, setEhpadId] = useState("");
    const [tournee, setTournee] = useState("");
    const [patientSearch, setPatientSearch] = useState("");
    const [produitSearch, setProduitSearch] = useState("");

    useEffect(() => {
        API.get("/ehpads")
            .then(r => setEhpads(r.data || []))
            .catch(() => {})
            .finally(() => setEhpadsLoaded(true));
        API.get("/ehpads/tournees").then(r => setTournees(r.data || [])).catch(() => {});
    }, []);

    return {
        ehpads,
        ehpadsLoaded,
        tournees,
        values: { dateReception, statutMode, ehpadId, tournee, patientSearch, produitSearch },
        setters: { setDateReception, setStatutMode, setEhpadId, setTournee, setPatientSearch, setProduitSearch },
    };
}
